const navigation = {
    init() {
        this.appendNavLinkParams();
    },

    /**
     * Attaches a mouseenter event to navigation links and appends a tracking parameter
     * to the URL when hovered.
     */
    appendNavLinkParams() {
        const navbar = $('#navigation');

        if (navbar.length) {
            const menuCategory = navbar.find('.menu-category');
            const navParams = menuCategory.data('nav-params');
            let parsedParams = {};
            try {
                parsedParams = typeof navParams === 'string' ? JSON.parse(navParams) : navParams;

                if (Object.keys(parsedParams).length) {
                    $('.menu-category a').on('mouseenter', function handleNavHover() {
                        if ($(this).attr('data-enhanced')) return;

                        const currentHref = $(this).attr('href');
                        if (!currentHref) return;

                        try {
                            const url = new URL(currentHref, window.location.origin);

                            Object.entries(parsedParams).forEach(([key, value]) => {
                                url.searchParams.set(key, value);
                            });

                            $(this).attr('href', url.toString());

                            // data-enhanced="true" to skip processing on hover again.
                            $(this).attr('data-enhanced', true);
                        } catch (err) {
                            console.warn('Invalid URL:', currentHref, err);
                        }
                    });
                }
            } catch (e) {
                console.error('appendNavLinkParams: Failed to parse navParams:', navParams, e);
            }
        }
    },
};

module.exports = navigation;
